import { Component, OnInit } from '@angular/core';
import { User } from '../../../model/user/User';
import { AppState } from '../../../store/app.states';
import { Store } from '@ngrx/store';
import { PatientService } from '../../../services/patient.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-questionnaires-completed',
  templateUrl: './questionnaires-completed.component.html',
  styleUrls: ['./questionnaires-completed.component.css']
})
export class QuestionnairesCompletedComponent implements OnInit {
  user: User | null;
  questionnaires: string[];
  title = 'Questionari completati';
  destination = 'landing';

  constructor(private store: Store<AppState>, private patientService: PatientService,
    private router: Router) {
    document.addEventListener('notification', () => {
      console.log('EVENT UPDATE??????');
      this.patientService.getUpdatedQuestionnaires().subscribe(res => {
        localStorage.setItem('questionnaires', JSON.stringify(res));
        this.questionnaires = res.sort().filter(q => !q.includes('CLINICAL'));
        if (this.questionnaires === null || this.questionnaires === undefined) {
          this.questionnaires = [];
        }
      });
    });
  }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.questionnaires = JSON.parse(localStorage.getItem('questionnaires'));
    if (this.questionnaires === null || this.questionnaires === undefined) {
      this.questionnaires = [];
    }
    this.questionnaires = this.questionnaires.slice().sort().filter(q => !q.includes('CLINICAL'));
    this.dispatching();
  }

  dispatching() {
    if (this.questionnaires !== null && this.questionnaires !== undefined) {
      this.questionnaires.forEach(type => {
        console.log(type);
        switch (type) {
          /*case 'CLINICAL-SCCAI':
            this.patientService.getQuestionnairesClinicalSCCAI(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('clinical-sccai', JSON.stringify(res.body));
              }
            });
            break;
          case 'CLINICAL-HBI':
            this.patientService.getQuestionnairesClinicalHBI(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('clinical-hbi', JSON.stringify(res.body));
              }
            });
            break;
          case 'CLINICAL-PRISM':
            this.patientService.getQuestionnairesClinicalPRISM(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('clinical-prism', JSON.stringify(res.body));
              }
            });
            break;*/
          case 'CLINICAL-SCCAI':
          case 'CLINICAL-HBI':
          case 'CLINICAL-PRISM':
            break;
          case 'EORTC-QLQ':
            this.patientService.getQuestionnairesEORTC(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('eortc-qlq', JSON.stringify(res.body));
              }
            });
            break;
          case 'EQ5D5L':
            this.patientService.getQuestionnairesEQ5D5L(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('eq5d5l', JSON.stringify(res.body));
              }
            });
            break;
          case 'HADS':
            this.patientService.getQuestionnairesHADS(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('hads', JSON.stringify(res.body));
              }
            });
            break;
          case 'HBI':
            this.patientService.getQuestionnairesHBI(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('hbi', JSON.stringify(res.body));
              }
            });
            break;
          case 'IBD-DISK':
            this.patientService.getQuestionnairesIBDDisk(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('ibd-disk', JSON.stringify(res.body));
              }
            });
            break;
          case 'IPAQ-SF':
            this.patientService.getQuestionnairesIPAQSF(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('ipaq-sf', JSON.stringify(res.body));
              }
            });
            break;
          case 'MIAH-CD':
            this.patientService.getQuestionnairesMIAHCD(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('miah-cd', JSON.stringify(res.body));
              }
            });
            break;
          case 'MIAH-UC':
            this.patientService.getQuestionnairesMIAHUC(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('miah-uc', JSON.stringify(res.body));
              }
            });
            break;
          case 'MMAS8':
            this.patientService.getQuestionnairesMMAS8(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('mmas8', JSON.stringify(res.body));
              }
            });
            break;
          case 'PATIENT-SCCAI':
            this.patientService.getQuestionnairesPatientSCCAI(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('patient-sccai', JSON.stringify(res.body));
              }
            });
            break;
          case 'PHQ9':
            this.patientService.getQuestionnairesPHQ9(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('phq9', JSON.stringify(res.body));
              }
            });
            break;
          case 'PRISM':
            this.patientService.getQuestionnairesPRISM(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('prism', JSON.stringify(res.body));
              }
            });
            break;
          case 'PSQI':
            this.patientService.getQuestionnairesPSQI(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('psqi', JSON.stringify(res.body));
              }
            });
            break;
          case 'SIBDQ':
            this.patientService.getQuestionnairesSIBDQ(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('sibdq', JSON.stringify(res.body));
              }
            });
            break;
          case 'IBDQ':
            this.patientService.getQuestionnairesIBDQ(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('ibdq', JSON.stringify(res.body));
              }
            });
            break;
          case 'LARS':
            this.patientService.getQuestionnairesLARS(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('lars', JSON.stringify(res.body));
              }
            });
            break;
          case 'TSQM':
            this.patientService.getQuestionnairesTSQM(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('tsqm', JSON.stringify(res.body));
              }
            });
            break;
          case 'WPAI':
            this.patientService.getQuestionnairesWPAI(type).subscribe(res => {
              if (res.status === 200) {
                localStorage.setItem('wpai', JSON.stringify(res.body));
              }
            });
            break;
        }
      });
    }
  }

  length(q: string): number {
    const arr = JSON.parse(localStorage.getItem(q.toLowerCase()));
    if (arr !== null && arr !== undefined) {
      return arr.length;
    } else {
      return 0;
    }
  }

  goToPage(q: string) {
    this.router.navigateByUrl('questionnaires-show/' + q.toLowerCase());
  }
}
